<template>
  <div>
    <app-button :disabled="isLoading" data-qa="download-stock-cars-excel-button" @click="download">
      {{ i18n.t('/StockDashboard/DownloadExcelButton') }}
      <loader v-if="isLoading" />
    </app-button>
  </div>
</template>

<script>
import AppButton from '@/components/generic/presentational/atoms/appButton/AppButton.vue'
import Loader from '@/components/generic/presentational/atoms/loader/Loader.vue'
import axios from 'axios'
import { saveAs } from 'file-saver'

export default {
  components: {
    AppButton,
    Loader,
  },
  data() {
    return {
      isLoading: false,
      i18n: window.VUE_CLI_EXPORTS.plugins.i18n,
    }
  },
  methods: {
    async download() {
      try {
        this.isLoading = true
        const response = await axios.get(`GetStockCarsExcel`, {
          responseType: 'blob',
        })
        let fileName = response.headers['content-disposition'].split('filename=')[1].split(';')[0]
        saveAs(response.data, fileName)
      } catch (e) {
        return Promise.reject(e)
      } finally {
        this.isLoading = false
      }
    },
  },
}
</script>

<style></style>
